// 「吃瓜百科」术语数据 —— 分类 + 名词速览
// 说明：内容为静态展示数据，用于名词速览卡片与详情弹窗

export const termCategories = [
  { key: "全部", label: "全部" },
  { key: "塌房", label: "塌房与翻车" },
  { key: "实锤", label: "证据与实锤" },
  { key: "粉丝", label: "粉丝与舆论" },
  { key: "营销", label: "营销与操作" },
  { key: "热梗", label: "网络热梗" },
  { key: "典故", label: "典故与来源" },
];

export const terms = [
  {
    id: "ta-fang",
    title: "塌房",
    category: "塌房",
    tag: "热梗",
    hot: 98,
    summary: "指自己喜欢的明星、偶像或公众人物爆出负面事件，让人设在一瞬间崩塌。",
    content: [
      "「塌房」是粉丝圈常用词，最初形容追星女孩心爱的偶像因丑闻、违法或失德事件而人设崩塌，就像自己盖的「房子」忽然塌了一样，内心的寄托瞬间落空。",
      "这个词最早从选秀、追星语境流行起来，后来泛化到体育、财经、创业等各个领域：自己喜欢的球队主帅下课、信任的博主翻车、追捧的公司暴雷，都被称为「塌房」。",
      "严格来说，「塌房」强调的是粉丝视角的主观感受——重点不是事件本身有多严重，而是它击碎了粉丝对这个人「完美滤镜」的想象。",
    ],
    origin: "源自 2019 年前后饭圈文化，取「房子塌了」的比喻，后经社交平台广泛传播成为全民热梗。",
    usage: "常见表达：\"我家房子塌了\"（我偶像出事了）、\"塌房预警\"（可能出事的征兆）。",
    tips: "法律上，若艺人因偷逃税、嫖娼等违法被「锤」，塌房往往伴随着行政处罚或民事追偿，围观时可多关注官方通报而非仅停留在八卦层面。",
    related: ["实锤", "人设崩塌", "反转"],
  },
  {
    id: "fan-che",
    title: "翻车",
    category: "塌房",
    tag: "热梗",
    hot: 90,
    summary: "原本信心满满的操作最后失败出糗，把事情搞砸了。",
    content: [
      "「翻车」本指车辆倾覆，网络语境里指原本被看好、被期待的操作最终惨淡收场，事与愿违地出了大糗。",
      "它可以用于很多场景：主播带货时商品质量翻车、明星直播时口误翻车、公司营销方案被群嘲翻车、求职者在面试中表现失常也能自嘲「翻车」。",
      "和「塌房」相比，「翻车」更侧重「事」的失败本身，情绪也相对轻松，常用于自嘲或调侃，不一定涉及道德问题。",
    ],
    origin: "来自「翻车现场」一词，早期多用于贴吧、论坛形容失败的搞笑场面，如今是主流社交平台高频词。",
    usage: "常见表达：\"这波直播翻车了\"\"翻车现场名场面\"。",
    tips: "翻车不等于塌房：翻车多指操作失误被群嘲，塌房多指偶像人设崩塌，两者严重程度与适用范围有明显区别。",
    related: ["塌房", "回旋镖", "破防"],
  },
  {
    id: "ren-she",
    title: "人设崩塌",
    category: "塌房",
    tag: "行业黑话",
    hot: 86,
    summary: "公众人物精心维持的形象被真实行为击碎，前后不一引发群嘲。",
    content: [
      "「人设」指公众人物在镜头前刻意塑造的公众形象，如「学霸人设」「好男人人设」「耿直人设」。当真实言行与这种人设严重不符并被曝光，就叫「人设崩塌」。",
      "人设崩塌之所以杀伤力大，是因为它直接摧毁信任基础——受众会发现以往相信的「真诚」其实是一场表演，欺骗感远大于事件本身。",
      "传播学视角下，人设崩塌本质是一种「信任危机」，处理不当往往会带来持续的舆论反噬，比单一负面新闻更难挽回。",
    ],
    origin: "「人设」一词源于动漫游戏的角色设定，后被借用进娱乐圈与大众传播语境。",
    usage: "常见表达：\"他学霸人设崩了\"\"立人设容易，翻车也快\"。",
    tips: "理性吃瓜提示：人设崩塌常伴随「实锤」证据链，判断时应区分事实与情绪化声讨。",
    related: ["塌房", "实锤", "控评"],
  },
  {
    id: "shi-chui",
    title: "实锤",
    category: "实锤",
    tag: "行业黑话",
    hot: 95,
    summary: "指无可辩驳、坐实传闻的真实证据，一旦实锤基本等于板上钉钉。",
    content: [
      "「实锤」指能够坐实某个传闻或指控的硬性证据，比如录音、截图、视频、官方通报等。有了实锤，原本的「据说」「疑似」就升级为「属实」。",
      "吃瓜过程中，粉丝常喊「求锤得锤」——意思是当一方拒不承认时，放料方会追加更硬的证据，直到对方无话可说。",
      "媒体与舆论更看重「实锤」而非情绪化指控，因为它意味着信息经过了事实层面的检验，降低了造谣与误伤的概率。",
    ],
    origin: "「锤」取义「一锤定音」，指证据像锤子一样把悬而未决的事彻底敲定，约在 2016 年后的八卦语境中广泛使用。",
    usage: "常见表达：\"有没有实锤？\"\"对方直接甩实锤了\"\"求锤得锤\"。",
    tips: "面对「实锤」也建议多方核实：截图可 P、录音可剪辑，真正权威的是官方通报与司法机关认定。",
    related: ["塌房", "反转", "澄清"],
  },
  {
    id: "liao",
    title: "料 / 放料",
    category: "实锤",
    tag: "行业黑话",
    hot: 82,
    summary: "指尚未被证实的内部消息或猛料，放料的人掌握着吃瓜群众看不到的信息。",
    content: [
      "吃瓜语境里的「料」泛指关于某人某事的内部消息、私密信息或丑闻，通常由「知情者」或营销号放出来，是引发吃瓜热潮的源头。",
      "「料」有真有假、有深有浅：有的只是捕风捉影的「瓜皮」，有的则能引出后来被实锤的「大瓜」，围观时需要保持判断力。",
      "从「放料」到「反转」再到「实锤」，往往是一条完整的信息链，也最能体现网络舆论场的复杂性。",
    ],
    origin: "「料」在港台娱乐记者报道文化中流行，后传入内地互联网，成为爆料文化的固定用语。",
    usage: "常见表达：\"有大料\"\"先放个料看看\"\"这料保熟吗\"。",
    tips: "「料」在法律层面属于未经证实的信息，捏造传播谣言可能涉嫌侵犯名誉权或构成造谣，理性吃瓜更要做到「让子弹飞一会儿」。",
    related: ["实锤", "营销号", "反转"],
  },
  {
    id: "reversal",
    title: "反转",
    category: "实锤",
    tag: "热梗",
    hot: 88,
    summary: "事件剧情在后续信息出现后彻底掉头，之前的判断被推翻。",
    content: [
      "「反转」指舆论事件在持续发酵中，因为新的证据或真相曝光，剧情发生 180 度大转弯，最初被声讨的一方可能是受害者，被同情的可能另有隐情。",
      "反转频发是碎片化信息时代的特点：人们往往在信息不全时就急于表态，等后续证据浮现才发现「站错了队」。",
      "经历多次「狼来了」后，越来越多的网友学会了「让子弹飞一会儿」，不急着下结论，这也是近年来舆论素养提升的表现。",
    ],
    origin: "源于影视与文学中「剧情反转」的叙事手法，后被用来形容真实舆论事件里的剧情大转弯。",
    usage: "常见表达：\"这瓜还有反转\"\"静等反转打脸\"。",
    tips: "反转提醒我们：情绪先行最容易被带节奏，等权威信息完整呈现后再表态，是更成熟的吃瓜姿势。",
    related: ["实锤", "澄清", "吃瓜群众"],
  },
  {
    id: "kong-ping",
    title: "控评",
    category: "粉丝",
    tag: "行业黑话",
    hot: 84,
    summary: "粉丝或团队通过集中点赞、发好评来占领评论区，压制负面声音。",
    content: [
      "「控评」指粉丝群体或公关团队在偶像相关微博、新闻评论区集中发布正面言论并点赞顶到前排，以营造「舆论一片大好」或压制负面评论的现象。",
      "控评通常有组织、有规模：后援会提前发布「控评文案」，粉丝按要求统一评论口径，短时间内把前排占满。",
      "对路人而言，过度控评反而会激起反感，让真实的讨论被淹没，也常被戏称为「捂嘴」。",
    ],
    origin: "源自「控制评论」的缩写，随着流量明星与粉丝应援文化兴起而成为饭圈标配操作。",
    usage: "常见表达：\"他家控评太狠了\"\"空瓶（控评的谐音）大军来了\"。",
    tips: "控评是网络营销与饭圈文化的典型操作，理解它能帮你在刷评论区时看穿「前排好评」背后的组织化运作。",
    related: ["营销号", "洗地", "下场"],
  },
  {
    id: "xia-chang",
    title: "下场",
    category: "粉丝",
    tag: "行业黑话",
    hot: 76,
    summary: "原本旁观的人或官方亲自出手参与争论、回击，从围观变成当事人。",
    content: [
      "「下场」在饭圈与舆论语境中指原本处于旁观位置的一方主动出手介入对抗，亲自下场发言、回击或站队。",
      "常见表达有「亲自下场撕」「工作室下场回应」「官方下场整治」——同样是下场，当事人回击与监管部门介入的性质截然不同。",
      "吃瓜时判断「谁先下场」往往能看出事件中各方真实意图，也常成为舆论分析的重点切入点。",
    ],
    origin: "源自棋牌与体育语境中「下场比试」的说法，后延伸至网络论战。",
    usage: "常见表达：\"正主亲自下场了\"\"官方下场，事情就大了\"。",
    tips: "当官方下场（如市场监管、警方介入），意味着事件可能已超出八卦范畴，进入依法处理阶段。",
    related: ["控评", "洗地", "出警"],
  },
  {
    id: "xi-di",
    title: "洗地",
    category: "粉丝",
    tag: "行业黑话",
    hot: 74,
    summary: "为做错事的一方强行辩解、美化，试图洗清责任或转移焦点。",
    content: [
      "「洗地」指在负面事件发生后，有人通过强行合理化、转移重点、反咬受害者等方式，为犯错一方辩解或洗白的行为。",
      "洗地的常见话术包括「一个巴掌拍不响」「都是对家陷害」「先看看对方黑历史」等，本质是回避核心事实、模糊责任边界。",
      "过度洗地不仅难以服众，反而容易「越洗越黑」，把本来可以道歉解决的小事推向更大的舆论反噬。",
    ],
    origin: "取「把地上的脏污洗干净」的比喻，网络语境中带明显贬义，讽刺无底线辩护。",
    usage: "常见表达：\"别洗了，越洗越黑\"\"这洗地水平不行\"。",
    tips: "区分正常辩护与「洗地」的关键，是看对方是否正视并回应核心事实，而不是一味转移话题与推卸责任。",
    related: ["控评", "公关文", "回旋镖"],
  },
  {
    id: "marketing-hao",
    title: "营销号",
    category: "营销",
    tag: "行业黑话",
    hot: 80,
    summary: "以流量和商业利益为目标批量搬运、加工内容的自媒体账号，吃瓜信息的主要来源之一。",
    content: [
      "「营销号」指以获取流量、涨粉、接广告或引流为目的的互联网账号，常批量发布情感、娱乐、八卦、科普等「易爆款」内容。",
      "营销号制作内容看重的是流量而非事实：标题党、搬运剪切、断章取义、看图说话是其常见手法，很多「瓜」正是经由它们放大扩散。",
      "由于营销号数量庞大、门槛低，它们既贡献了海量信息，也大大增加了谣言与二手信息的传播风险，是吃瓜时必须警惕的信息源。",
    ],
    origin: "伴随微博、公众号等内容平台商业化的兴起而大量出现，与「自媒体」「水军」常被并列讨论。",
    usage: "常见表达：\"营销号又开始带节奏了\"\"这是营销号编的瓜\"。",
    tips: "看到营销号内容时，建议溯源到原始信源（当事人声明、官方通报、权威媒体），避免在二手信息里打转。",
    related: ["通稿", "蹭热度", "撤热搜"],
  },
  {
    id: "re-hot",
    title: "热搜 / 撤热搜",
    category: "营销",
    tag: "行业黑话",
    hot: 85,
    summary: "热搜反映全网关注热点，而「撤热搜」则被普遍视为舆情干预的代名词。",
    content: [
      "「热搜」是平台根据用户搜索、讨论热度实时生成的热点榜单，上榜往往意味着事件进入全网视野，是舆情爆发的重要标志。",
      "「撤热搜」指通过公关手段让负面话题从榜单上快速消失，常见于明星与企业的危机公关中，一旦被网友发现话题「凭空消失」，往往会激起更大的反感与逆反。",
      "「买热搜」则相反，是主动花钱把话题推上榜营造热度，常被用来「造势」「蹭热点」或转移公众注意力。",
    ],
    origin: "随微博热搜机制走红，「上热搜 / 撤热搜 / 买热搜」构成一套完整的网络热度话语体系。",
    usage: "常见表达：\"刚上热搜就没了\"\"又撤热搜了？\"\"这热度明显是买的\"。",
    tips: "热搜不等于真相：上榜话题经过了热度放大，真伪仍需核对原始信源，避免被「热搜节奏」牵着走。",
    related: ["营销号", "蹭热度", "公关文"],
  },
  {
    id: "gong-guan",
    title: "公关文",
    category: "营销",
    tag: "行业黑话",
    hot: 72,
    summary: "危机发生后当事方发布的官方声明，措辞讲究，能从中读出不少言外之意。",
    content: [
      "「公关文」指企业或个人在负面舆情发生时发布的官方声明、回应或通稿，目的是澄清、降温、止损或争取舆论支持。",
      "熟练的吃瓜者会逐字分析公关文：用词是「深表遗憾」还是「坚决否认」，有没有直接回应核心质疑，是「道歉」还是「解释」，细节里往往藏着事件走向的线索。",
      "公关文也常因避重就轻、避实就虚而被网友调侃为「小作文」「甩锅文」，写法与态度直接影响二次舆情走势。",
    ],
    origin: "源自企业公共关系（Public Relations）的文案写作，后被泛化进各类网络危机处置语境。",
    usage: "常见表达：\"看他公关文怎么圆\"\"这声明避重就轻\"。",
    tips: "判断一份公关文是否「过关」，可看三点：是否直面核心事实、是否给出可验证的处理措施、态度是否与行为一致。",
    related: ["小作文", "反转", "实锤"],
  },
  {
    id: "po-fang",
    title: "破防",
    category: "热梗",
    tag: "热梗",
    hot: 89,
    summary: "原本坚强或冷静的心理防线被击中，瞬间情绪涌上心头。",
    content: [
      "「破防」原指游戏中打破对方的防御，网络语境里则形容人的心理防线被一句话、一件事瞬间击穿，情绪强烈上头。",
      "破防可以是伤感的（看到意难平的故事泪目），也可以是愤怒的（被无良操作气到），涵盖从感动到崩溃的各种强烈情绪。",
      "作为高频弹幕与评论词，「破防」逐渐从游戏圈走向大众，成为形容情绪波动的通用表达。",
    ],
    origin: "源自游戏术语「突破防线」，约 2019 年后在弹幕文化与短视频评论中广泛流行。",
    usage: "常见表达：\"真破防了\"\"这结局太让人破防了\"。",
    tips: "「破防」常用于真情流露的时刻，和代表无力感的「emo」、代表失落的「自闭」意思相近但情绪浓度不同。",
    related: ["emo", "emo 是啥", "真香"],
  },
  {
    id: "emo",
    title: "emo",
    category: "热梗",
    tag: "热梗",
    hot: 79,
    summary: "处于低落、丧气、情绪内耗的状态，用来描述深夜伤感的自己。",
    content: [
      "「emo」取自英文 emotional（情绪化）的缩写，最初指一种强调情绪化的摇滚亚文化，如今在网上则普遍用来形容「emo 了」，即情绪低落、丧、emo 上头。",
      "年轻人喜欢在深夜「网抑云」时自嘲「我又 emo 了」，配上伤感的歌和文案，成为当代互联网情绪表达的重要符号。",
      "适度自嘲是情绪出口，但若长期处于低落情绪影响生活，建议寻求身边人支持或专业帮助，而非只在网上宣泄。",
    ],
    origin: "从 emo 摇滚亚文化到「网抑云」梗，emo 完成了从音乐流派到全民情绪词的身份转变。",
    usage: "常见表达：\"深夜 emo 了\"\"emo 就 emo，明天还得上班\"。",
    tips: "与「破防」的瞬间被击中不同，「emo」更偏向一种持续的、氛围性的低落状态。",
    related: ["破防", "真香", "内卷"],
  },
  {
    id: "zhen-xiang",
    title: "真香",
    category: "热梗",
    tag: "热梗",
    hot: 70,
    summary: "嘴上说着不要，行动却很诚实，最后啪啪打脸却乐在其中。",
    content: [
      "「真香」形容一个人最初坚决拒绝某件事，结果尝试后瞬间被打脸并真心喜欢上的「言行不一」喜剧场面。",
      "它脱胎于综艺里某嘉宾起初放话「我饿死也不吃这个」，结果尝了一口立刻改口「真香」的名场面，成为形容「口嫌体正直」的万能梗。",
      "如今「真香」被广泛用于消费、追剧、职业选择等场景，自带轻松幽默的喜感。",
    ],
    origin: "出自湖南卫视综艺《变形记》的经典片段，经表情包与二创传播成为现象级网络梗。",
    usage: "常见表达：\"嘴上说不要，身体却很诚实\"\"真香定律虽迟但到\"。",
    tips: "「真香定律」还常被用来调侃反复横跳、立场不坚定的人，语气多为调侃而非指责。",
    related: ["打脸", "端水大师", "阴阳怪气"],
  },
  {
    id: "chi-gua",
    title: "吃瓜群众",
    category: "典故",
    tag: "典故",
    hot: 99,
    summary: "围观热点事件却不出声表态的普通路人，网络事件的第一批观众。",
    content: [
      "「吃瓜群众」泛指在网络上围观热点事件、津津有味地看热闹却不轻易站队表态的普通网友，是网络舆论场最庞大的一群人。",
      "这个词有自嘲成分，也有旁观者心态的体现：群众们一边嗑瓜子看戏，一边催更、蹲后续，是推动话题热度的重要力量。",
      "从「吃瓜」到「理性吃瓜」，这个词也逐渐演化为一种对网络围观文化的概括，提醒人们在围观中保持独立思考。",
    ],
    origin: "「吃瓜」与「嗑瓜子看戏」的老传统一脉相承，鲁迅笔下的看客文化被认为是其精神前身，2016 年后随网络热帖全面走红。",
    usage: "常见表达：\"前排吃瓜\"\"吃瓜群众已就位\"\"搬好小板凳看戏\"。",
    tips: "吃瓜群众的本质是「围观」，既推动信息传播，也承担着辨别真伪、防止谣言扩散的责任。",
    related: ["猹与闰土", "瓜田", "反转"],
  },
  {
    id: "zha-rundu",
    title: "猹与闰土",
    category: "典故",
    tag: "典故",
    hot: 83,
    summary: "吃瓜名场面：大家是猹，爆料的人是闰土，手里的瓜是钢叉下的瓜。",
    content: [
      "「猹与闰土」是吃瓜圈最经典的比喻之一：鲁迅《故乡》里月下持钢叉的闰土，成了「放瓜人 / 爆料人」的代称，被爆料的消息则被戏称为「瓜」。",
      "而在线吃瓜、蹲瓜的群众，则被比作鲁迅笔下在瓜田里偷瓜、却被闰土一叉子插中的「猹」——吃瓜反而被瓜砸中的「猹」，完美诠释了吃瓜群众的处境。",
      "这个梗让原本高冷的文学人物走进互联网热梗，实现了「老梗新用」，也是传统文化在当代传播中的生动案例。",
    ],
    origin: "出自鲁迅小说《故乡》中闰土「深蓝天空下，手捏一柄钢叉，向一匹猹刺去」的经典描写，网友借其构设吃瓜叙事。",
    usage: "常见表达：\"闰土又出来放瓜了\"\"小心被猹反咬\"\"没想到猹竟是我自己\"。",
    tips: "「猹是猹，闰土是闰土」，文学形象与网络比喻被重新组合，是当代网民基于经典文学的二次创作。",
    related: ["吃瓜群众", "瓜田", "前排吃瓜"],
  },
  {
    id: "gua-tian",
    title: "瓜田",
    category: "典故",
    tag: "典故",
    hot: 77,
    summary: "网络上的八卦信息来源汇聚地，种瓜、产瓜、吃瓜都在这一亩三分地里。",
    content: [
      "「瓜田」是对八卦信息来源与聚集地的形象称呼——明星爆料、网红互撕、平台热搜汇聚成一片「吃瓜圣地」，网友纷纷前来蹲守。",
      "瓜田里「猹」群结队，「闰土」不定期放料，瓜被越种越多、越滚越大，形成独特的吃瓜生态。",
      "「瓜田李下」原指容易引起嫌疑的处境，网络把它轻松化之后，专指网友聚集围观八卦的乐土。",
    ],
    origin: "由「吃瓜」「猹与闰土」等梗衍生而来，与鲁迅《故乡》中的「瓜田」意象一脉相承。",
    usage: "常见表达：\"瓜田已就位，坐等上瓜\"\"这片瓜田太热闹了\"。",
    tips: "瓜田虽热闹，也要注意别「吃瓜吃到自己头上」——谨防在瓜田里无意间传播未经证实的谣言。",
    related: ["猹与闰土", "吃瓜群众", "前排吃瓜"],
  },
  {
    id: "qian-pai",
    title: "前排吃瓜 / 蹲一个",
    category: "典故",
    tag: "热梗",
    hot: 68,
    summary: "抢在事件最前面占好位置看戏，顺便蹲等后续更新。",
    content: [
      "「前排吃瓜」指在网络讨论中抢占靠前的回复位置围观事件，象征「第一时间到场」的吃瓜热情，常有「前排出售瓜子板凳」的调侃接龙。",
      "「蹲一个」则是在话题下留下脚印，等着事件后续更新时回来继续吃瓜，像极了守在瓜田等瓜熟的猹。",
      "这类表达让围观者从「被动接收」变成「主动蹲守」，是吃瓜文化中参与感的体现。",
    ],
    origin: "源自论坛「占楼」「沙发」文化，后演化出「前排吃瓜」「蹲后续」「蹲一个」等系列吃瓜用语。",
    usage: "常见表达：\"前排吃瓜\"\"蹲一个后续\"\"蹲到了，谢谢楼主\"。",
    tips: "「蹲一个」背后是信息更新的焦虑，理性吃瓜不妨给事件留出核实时间，避免过早下结论。",
    related: ["吃瓜群众", "瓜田", "反转"],
  },
  {
    id: "hui-xuan-biao",
    title: "回旋镖",
    category: "塌房",
    tag: "热梗",
    hot: 78,
    summary: "自己说过的话、做过的事，最终反过来砸向自己，堪称报应文学现场。",
    content: [
      "「回旋镖」指某人曾经针对他人说过的话、立过的规矩、做过的事，最终反向作用于自己身上，被网友调侃为「飞出去的镖砸回来」。",
      "它常在舆论反转或当事人翻车时被拿出来「考古」：当年骂别人的话，如今成了自己的写照；当初立下的 flag，如今亲手打破。",
      "「回旋镖」自带讽刺与喜剧色彩，网友热衷整理「回旋镖合集」，用以呈现舆论场中前后不一的反差。",
    ],
    origin: "回旋镖（boomerang）本是澳大利亚原住民的投掷武器，因其「飞出去会飞回来」的特性被借用来比喻言行反噬。",
    usage: "常见表达：\"回旋镖来了\"\"他的回旋镖正中眉心\"。",
    tips: "回旋镖提醒内容创作者与公众人物：网络是有记忆的，言行一致才是最长久的「人设」。",
    related: ["人设崩塌", "翻车", "真香"],
  },
];